import { Role } from "../../../../packages/vars/src";

export interface NavigationItem {
	label: string;
	icon: React.ElementType;
	isActive?: boolean;
	href: string;
	disabled?: boolean;
	roles?: Role[];
	activePattern?: string | string[];
}

export const isActive = (
	currentPath: string,
	item: NavigationItem,
): boolean => {
	if (!item.activePattern) {
		if (item.href === "/") {
			return currentPath === item.href;
		}
		return currentPath.startsWith(item.href);
	}

	const patterns = Array.isArray(item.activePattern)
		? item.activePattern
		: [item.activePattern];

	return patterns.some((pattern) => {
		if (!pattern.includes(":")) {
			return currentPath.startsWith(pattern);
		}

		const patternParts = pattern.split("/").filter(Boolean);
		const pathParts = currentPath.split("/").filter(Boolean);

		if (pathParts.length !== patternParts.length) {
			return false;
		}

		return patternParts.every((part, index) => {
			if (part.startsWith(":")) {
				return true;
			}
			return part === pathParts[index];
		});
	});
};
